import { useTranslation } from 'react-i18next'

import { MagnifyingGlassIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, Link, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NoRecentOrders = ({ contactEmail, onBackToStart }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.Heading>
        <MagnifyingGlassIcon size={40} color={theme.title.primary} />
        <Text type="titleM">{t('No hay pedidos recientes que mostrar')}</Text>
      </Styles.Heading>
      <Text type="bodyMRegular">
        {t(
          'No hemos encontrado pedidos recientes. Si crees que esto es un error o necesitas devolver un pedido más antiguo, contacta con nuestro equipo de soporte.'
        )}
      </Text>
      <Button fullWidth onClick={onBackToStart}>
        {t('Volver al inicio')}
      </Button>
      {contactEmail && (
        <Styles.ContactContainer>
          <Link href={`mailto:${contactEmail}`}>
            <Text type="bodyMBold" color={theme.title.primary}>
              {t('Contactar con soporte')}
            </Text>
          </Link>
        </Styles.ContactContainer>
      )}
    </Styles.Container>
  )
}

export default NoRecentOrders
